// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AlmaConfig = () => (custom_data: any) => custom_data.alma

const AuthenticationConfig = () => (custom_data: any) => ({
   enabled: custom_data.authentication.enabled,
   onlyUseRedirect: custom_data.authentication.only_use_redirect,
   sessionSeconds: custom_data.authentication.session_minutes * 60,
   keepAuthenticatedSessionAlive: custom_data.authentication.session_keep_alive,
   logoutSummonOnly: custom_data.authentication.logout_summon_only,

   // 'SAML', 'CAS' or 'Both'
   sierraAuthProtocol: custom_data.sierra?.authentication_protocol || 'SAML',

   samlAlias: custom_data.saml.saml_idp_alias,
   useSamlForSearchApiAuth: custom_data.saml.saml_is_primary_auth,
   samlForPrivateSite: custom_data.site.private && custom_data.saml.saml_is_primary_auth,

   // a saml IdP has likely been configured in admin panel for this client
   samlConfigurationExists: custom_data.saml.saml_configuration_exists,

   // configs have likely been added for consuming the client's cas instance
   casConfigurationExists: custom_data.authentication.service === 'cas' && (custom_data.sierra?.rta_enabled || false),
   ltiConfigurationExists: !!custom_data.lti?.lti_issuer_id_exists,


   // these providers are configured for all summon clients globally 
   oAuthProviders: ['microsoft', 'google'],
   referUrlAuth: custom_data.site.referred_url_authenticated,
   vpnAuthenticated: custom_data.info.authenticated
})

const AltmetricsConfig = () => (custom_data: any) => ({
   altmetrics_search_results: custom_data.widgets.altmetrics_search_results,
   altmetrics_quicklook: custom_data.widgets.altmetrics_quicklook,
   altmetrics_detail_page: custom_data.widgets.altmetrics_detail_page
})

const AssetsConfig = () => (function(custom_data: any) {
   const {
      site
   } = custom_data
   return {
      home: site.home,
      title: site.title,
      logoSmall: site.small_logo_url,
      logoSmallWidth: site.small_logo_width,
      logoSmallHeight: site.small_logo_height,
      logoLarge: site.large_logo_url,
      logoLargeWidth: site.large_logo_width,
      logoLargeHeight: site.large_logo_height,
      favicon: site.favicon_url,
   }
})

const BxRecommenderConfig = () => (custom_data: any) => ({
   libHash: custom_data.info.libhash,
   linkResolver: custom_data.site.link_resolver
})

const CustomizerConfig = () => (custom_data: any) => ({
   customizerUrl: custom_data.site.customizer_url
})

const CustomSectionsConfig = () => (custom_data: any) => ({
   showMoreEnabled: custom_data.custom_sections.show_more_enabled,
   defaultSectionsDisplayed: custom_data.custom_sections.default_sections_displayed,
   displayOrder: custom_data.custom_sections.display_order
})

const CustomLinksConfig = () => (custom_data: any) => ({
   customLinksList: custom_data.custom_links.custom_links,   
})

const DocumentConfig = () => (function(custom_data: any) {
   const detailPage = custom_data.detail_page
   return {
      enableGlanceability: custom_data.search_results.enable_glanceability,
      enableDetailPage: detailPage.enable_opac,
      enableAIPage: detailPage.enable_a_i,
      videoDBIDs: custom_data.info.video_dbids, // TODO: remove this once URIs are accessible via IEDL through API
      useGetForIllReq: detailPage.use_get_for_ill_requests
   }
})

const EnvConfig = () => (custom_data: any) => ({
   value: custom_data.info.env
})

const FeedbackConfig = () => (custom_data: any) => ({
   emailRequired: custom_data.site.client_email_required,
   enableFeedbackRoles: custom_data.site.enable_feedback_roles
})

const GoogleConfig = () => (function(custom_data: any) {
   const values = custom_data.google

   return {useProviderStorage: values.use_provider_storage === false ? false : true}
})

const HeadConfig = () => (custom_data: any) => ({
   title: custom_data.site.title,
   client: custom_data.info.name
})

const LocalizationConfig = () => (custom_data: any) => ({
   languages: custom_data.site.languages,
   defaultLanguage: custom_data.site.default_language
})

const MetricsConfig = () => (function(custom_data: any) {
   const metricsVals = custom_data.metrics
   const infoVals = custom_data.info

   return {
      url:            metricsVals.url,
      enabled:        metricsVals.enabled,
      client:         infoVals.name,
      authenticated:  infoVals.authenticated,
      clicktrackFormTargetsSelf: metricsVals.clicktrack_form_targets_self
   }
})

const MicrosoftConfig = () => (function(custom_data: any) {
   const values = custom_data.microsoft

   return {useProviderStorage: values.use_provider_storage === false ? false : true}
})

// Related to documents quicklook
const QuickLookConfig = () => (custom_data: any) => ({
   syndeticsClient: custom_data.info.syndeticsClient,
   enableSyndeticsPlus: custom_data.widgets.enable_syndeticsplus,
   showCallNums: custom_data.site.show_quicklook_callnums,
   showDeweys: custom_data.site.show_quicklook_deweys,
   displayCitationCounts: ((custom_data.search_results != null) ? custom_data.search_results.display_citation_counts_enabled : undefined),
   showPublicNotes: custom_data.search_results.display_eresource_public_notes,
   showLocationNotes: custom_data.search_results.display_eresource_location_notes,
   expandedItems: custom_data.quick_look ? custom_data.quick_look.quick_look_items : [],
   displayLibraryNotes: custom_data.quick_look.display_library_notes
})

const RecaptchaConfig = () => (custom_data: any) => {
   const recaptcha = custom_data.recaptcha || 
    custom_data?.email_settings?.recaptcha ||  {};

   return {
      siteKey:     
        recaptcha.site_key ||  recaptcha.siteKey  ||   
        null
   };
};

const RelatedItemsConfig = () => (custom_data: any) => ({
   libHash: custom_data.info.libhash,
   enabled: custom_data.search_results.enable_related_items
})

const SavedSearchAndItemsConfig = () => (custom_data: any) => ({
   searchEnabled: custom_data.advanced_search.saved_search,
   itemsEnabled: custom_data.advanced_search.saved_items,
   providers: custom_data.advanced_search.saved_search_types,
   savedItemsTimeout: custom_data.site.saved_items_timeout
})

const SearchConfig = () => (custom_data: any) => ({
   enableNewSearchButton: custom_data.search_results.enable_new_search_button,
   nonExactResultCount: custom_data.search_results.non_exact_result_count,
   hasSearchScopes: custom_data.search_scopes.filter((scope: any) => !scope.disabled).length > 0,
   searchScopes: custom_data.search_scopes.filter((scope: any) => !scope.disabled)
})

const SocialSharingServicesConfig = () => (function(custom_data: any) {
   // maybe make configurable which provider can be enabled/disabled?
   let socialSharingServices
   if (custom_data.site.enable_share_services) {
      return socialSharingServices = [
         { label: "Twitter",
            href: "https://twitter.com/intent/tweet/?text={TEXT}&url={URL}",
            fill: '#00ACEE;' },
         { label: "Facebook",
            href: "https://facebook.com/sharer/sharer.php?u={URL}", 
            fill: '#3B5998;' },
         { label: "Pinterest",
            href: "https://pinterest.com/pin/create/button/?url={URL}&media={URL}&description={TEXT}",
            fill: '#C8232C;' },
         { label: "LinkedIn",
            href: "https://www.linkedin.com/shareArticle?mini=true&url={URL}&title={TITLE}&summary={TEXT}&source={URL}", 
            fill: '#0E76A8;' },
         { label: "WhatsApp",
            href:  "https://web.whatsapp.com/send?text={TEXT}%20{URL}",
            hrefMobile: "whatsapp://send?text={TEXT}%20{URL}", 
            fill: '#4FCE5D;' },
         { label: "Telegram",
            href: "https://telegram.me/share/url?url={URL}&text={TEXT}",
            hrefMobile: "tg://msg?text={TEXT}", 
            fill: '#0088CC;' },
         { label: "Evernote",
            href: "https://www.evernote.com/clip.action?url={URL}&title={TEXT}", 
            fill: '#2EBE60;' }
      ]
   } else { 
      return socialSharingServices = []
   }
})

const SpringshareConfig = () => (custom_data: any) => custom_data.springshare

const TopicsConfig = () => (custom_data: any) => ({
   displayTopics: custom_data.custom_sections.display_order?.includes('topic-summary'),
   topics: custom_data.topics.topics_display
})

const WidgetsConfig = () => (custom_data: any) => ({
   enableWidgetsLink: custom_data.widgets.enable_widgets_link,
   enableAZSearchWidget: custom_data.custom_sections.display_order?.includes('az-search'),
   enableAZSearchWidgetAutoSearch: custom_data.widgets.enable_az_database_widget_auto_search,
   azDatabaseProxyUrl: custom_data.springshare.az_database_proxy_url,
   azBrowseUrl: custom_data.springshare.az_browse_url,
   secondaryClient : custom_data.info.secondaryClient,
   azDatabaseDefaultResults: custom_data.springshare.az_database_default_results
})

const RtaAvailabilityConfig = () => (custom_data: any) => ({
   isSierraClient: custom_data.sierra?.rta_enabled || false,
   rtaAvailableStatusMap: custom_data.sierra?.rta_available_status_map || [],
   rtaRequestableStatusMap: custom_data.sierra?.rta_requestable_status_map || [],
   rtaNotRequestableTypeMap: custom_data.sierra?.no_request_i_types?.split(",") || [],
   denyRequestIfNoDueDate: custom_data.sierra?.deny_request_if_no_due_date,
   dbs: custom_data.info.dbs,
   client: custom_data.info.name,
   showAbbreviatedRTA: custom_data.search_results.enable_short_availability_status,
   showLocationsColumn: custom_data.search_results.enable_locations_column,
   customAvailableCodes: custom_data.sierra?.custom_available_codes,
   customRequestableCodes: custom_data.sierra?.custom_requestable_codes
})

const LibraryCardConfig = () => (custom_data: any) => ({
   enableSierra: (custom_data.sierra?.api_integration_enabled && custom_data.sierra?.rta_enabled) || false,
   displayLibraryCard: (custom_data.sierra?.my_library_card && custom_data.sierra?.api_integration_enabled && custom_data.sierra?.rta_enabled) || false,
   editablePersonalDetails: custom_data.sierra?.editable_personal_details || [],
   displayReadingHistory: custom_data.sierra?.reading_history_enabled || false,
   webpacPatronInfoUrl: custom_data.sierra?.webpac_patron_info_base_url,
   customLibraryName: custom_data.sierra?.custom_library_name,
   sections: custom_data.sierra?.library_card_sections
})

const RefinePaneConfig = () => (custom_data: any) => ({
   selectedFacetsViewDisabled: custom_data.facets.selected_facets_view_disabled,
   independentFacetsScrollingEnabled: custom_data.facets.independent_scrolling_enabled_on
})

const BulkExportConfig = () => (custom_data: any) => ({
   libhash:custom_data.info.libhash,
   enabled: custom_data.search_results.allow_download_search_results
})

const ResearchAssistantConfig = () => (custom_data: any) => ({
   enabled: custom_data.research_assistant?.enable_research_assistant,
   citeLink: custom_data.research_assistant?.custom_citing_ai_content,
   disableHistory: custom_data.research_assistant?.disable_saved_search_history,
   session_id: custom_data.authentication?.session_id
})

const HomePageConfig = () => (custom_data: any) => ({
   sectionsOrder: custom_data.home_page?.sections_order || [],
   primaryAnnouncementsEnabled: custom_data.home_page?.primary_announcements?.some((a: any) => a.enabled),
   primaryAnnouncementsTitle: custom_data.home_page?.primary_announcement_section_title || "Announcements and events",
   primaryAnnouncements: custom_data.home_page?.primary_announcements || [],
   secondaryAnnouncementsEnabled: custom_data.home_page?.secondary_announcements?.some((a: any) => a.enabled),
   secondaryAnnouncements: custom_data.home_page?.secondary_announcements || [],
   cardsEnabled: custom_data.home_page?.linked_cards_section_enabled,
   cards: custom_data.home_page?.linked_cards || [],
   aboutLibraryEnabled: custom_data.home_page?.about_the_library_section_enabled,
   aboutLibraryTitle: custom_data.home_page?.about_the_library_section_title || "",
   aboutLibraryText: custom_data.home_page?.about_the_library_section_text || "",

   footerEnabled: custom_data.home_page?.footer_enabled,
   footerLogoUrl: custom_data.site.large_logo_url,
   footerLogoWidth: custom_data.site.large_logo_width,
   footerLogoHeight: custom_data.site.large_logo_height,
   footerLogoEnabled: custom_data.home_page?.include_summon_logo,
   footerLinks: custom_data.home_page?.footer_links || [],
   footerContactTitle: custom_data.home_page?.footer_contact_heading || '',
   footerContactText: custom_data.home_page?.footer_contact_text || '',

   homePageEnabled: custom_data.home_page?.enable_home_page_navigation || false,
})

angular.module('summonApp.factories.configs')
   .factory('authenticationConfig', AuthenticationConfig)
   .factory('almaConfig', AlmaConfig)
   .factory('altmetricsConfig', AltmetricsConfig)
   .factory('assetsConfig', AssetsConfig)
   .factory('bxRecommenderConfig', BxRecommenderConfig)
   .factory('customizerConfig', CustomizerConfig)
   .factory('customSectionsConfig', CustomSectionsConfig)
   .factory('customLinksConfig', CustomLinksConfig)
   .factory('documentConfig', DocumentConfig)
   .factory('envConfig', EnvConfig)
   .factory('feedbackConfig', FeedbackConfig)
   .factory('googleConfig', GoogleConfig)
   .factory('headConfig', HeadConfig)
   .factory('localizationConfig', LocalizationConfig)
   .factory('metricsConfig', MetricsConfig)
   .factory('microsoftConfig', MicrosoftConfig)
   .factory('quickLookConfig', QuickLookConfig)
   .factory('recaptchaConfig', RecaptchaConfig)
   .factory('relatedItemsConfig', RelatedItemsConfig)
   .factory('savedSearchAndItemsConfig', SavedSearchAndItemsConfig)
   .factory('searchConfig', SearchConfig)
   .factory('socialSharingServicesConfig', SocialSharingServicesConfig)
   .factory('springshareConfig', SpringshareConfig)
   .factory('topicsConfig', TopicsConfig)
   .factory('widgetsConfig', WidgetsConfig)
   .factory('rtaAvailabilityConfig', RtaAvailabilityConfig)
   .factory('libraryCardConfig', LibraryCardConfig)
   .factory('refinePaneConfig', RefinePaneConfig)
   .factory('bulkExportConfig', BulkExportConfig)
   .factory('researchAssistantConfig', ResearchAssistantConfig)
   .factory('homePageConfig', HomePageConfig)
